import classNames from 'classnames';
import * as PropTypes from 'prop-types';
import React from 'react';

import getTestProps from 'test/lib/cypress/getTestProps';
import DataTestAttrs from 'test/lib/cypress/shared/DataTestAttrs';

interface RowProps {
  className?: string;
  bufferRowReset?: boolean;
  children?: React.ReactNode;
  dataTestAttrs?: DataTestAttrs;
}

function Row(props: RowProps): JSX.Element {
  return (
    <div
      className={classNames('row', props.className, {bufferRowReset: props.bufferRowReset})}
      {...getTestProps(props.dataTestAttrs)}
    >
      {props.children}
    </div>
  );
}

Row.propTypes = {
  bufferRowReset: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
} as any;

export default Row;
